import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["percentageInput", "totalDisplay", "errorMessage", "indicator", "row", "destroyField"]
  static values = { systemCostId: Number }
  
  connect() {
    this.calculateTotal()
  }
  
  calculateTotal() {
    const total = this.percentageInputTargets.reduce((sum, input) => {
      const value = parseFloat(input.value) || 0
      return sum + value
    }, 0)
    
    if (this.hasTotalDisplayTarget) {
      this.totalDisplayTarget.textContent = `${total.toFixed(2)}%`
    }
    
    if (this.hasIndicatorTarget) {
      if (total === 100.0) {
        this.indicatorTarget.classList.remove("bg-red-100", "text-red-800")
        this.indicatorTarget.classList.add("bg-green-100", "text-green-800")
        this.indicatorTarget.textContent = "✓"
      } else {
        this.indicatorTarget.classList.remove("bg-green-100", "text-green-800")
        this.indicatorTarget.classList.add("bg-red-100", "text-red-800")
        this.indicatorTarget.textContent = "✗"
      }
    }
    
    if (this.hasErrorMessageTarget) {
      if (total === 100.0) {
        this.errorMessageTarget.textContent = ""
      } else {
        this.errorMessageTarget.textContent = `Campaign allocations must total 100%. Current total: ${total.toFixed(2)}%`
      }
    }
  }
  
  addCampaign(event) {
    event.preventDefault()
    const container = document.getElementById("campaign-allocations-container")
    if (!container) return
    
    // Generate a unique timestamp for the new record
    const timestamp = Date.now()
    const template = window.allocationRowTemplate.replace(/NEW_RECORD/g, timestamp)
    
    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = template
    
    // Get the new row element
    const newRow = tempDiv.firstElementChild
    
    // Append to container
    container.appendChild(newRow)
    
    // Reinitialize Stimulus controllers for the new row
    this.application.loadTargetsForScope(newRow)
    
    // Recalculate total
    this.calculateTotal()
  }
  
  removeAllocation(event) {
    if (confirm("Remove this campaign allocation? Remaining percentages will be redistributed evenly.")) {
      const row = event.target.closest(".allocation-row")
      if (!row) return
      
      // Get percentage inputs in this row
      const percentageInputs = Array.from(row.querySelectorAll("input[type='number'][name*='[percentage]']"))
      const removedPercentage = percentageInputs.reduce((sum, input) => {
        return sum + (parseFloat(input.value) || 0)
      }, 0)
      
      // Mark for destruction if it has an ID (existing record)
      const destroyField = row.querySelector("input[name*='[_destroy]']")
      const idField = row.querySelector("input[name*='[id]']")
      
      if (idField && idField.value) {
        // This is an existing record - mark for destruction
        if (destroyField) {
          destroyField.value = "1"
        }
        row.style.display = "none"
      } else {
        // This is a new record - just remove it
        row.remove()
      }
      
      // Redistribute remaining percentage evenly
      const remainingInputs = this.percentageInputTargets.filter(input => {
        const inputRow = input.closest(".allocation-row")
        return inputRow && inputRow.style.display !== "none" && inputRow !== row
      })
      
      if (remainingInputs.length > 0) {
        const perAllocation = (100.0 - removedPercentage) / remainingInputs.length
        remainingInputs.forEach(input => {
          input.value = perAllocation.toFixed(2)
        })
      }
      
      this.calculateTotal()
    }
  }
}

